<template>
  <div class="flowRecord">
    <div>
      <div class="steps">
        <div class="content" v-for="(item, index) in list" :key="index">
          <div class="content-icon">
            <div class="round">
              <i class="el-icon-check" v-if="item.handleTime"></i>
            </div>
            <div class="solid" v-show="index !== list.length - 1"></div>
          </div>
          <div class="content-text">
            <div class="title-box">
              <p class="title-text">{{ item.title }}</p>
            </div>
            <div class="box">
              <div
                class="imgs"
                v-show="item.title !== 'AI识别' && item.json.length > 0"
              >
                <img
                  v-for="(items, index) in item.json"
                  :key="index"
                  :src="items.url"
                  alt=""
                />
              </div>
              <div class="Ai" v-show="item.title == 'AI识别' && item.eventName">
                <span class="title-ai" v-show="item.eventName">
                  {{ item.eventName }}
                </span>
              </div>
              <div
                class="imgs"
                v-show="item.title == 'AI识别' && item.json.length > 0"
              >
                <img
                  v-for="(items, index) in item.json"
                  :key="index"
                  :src="items.url"
                  alt=""
                />
              </div>
              <p class="title-text" v-show="item.handleDetail">
                {{ item.handleDetail }}
              </p>
              <div class="dispose">
                <div v-show="item.title == '问题上报'">
                  <p>
                    上报人：
                    <span> {{ item.handleUserName }} </span>
                  </p>
                  <p>
                    上报时间：
                    <span> {{ item.handleTime }} </span>
                  </p>
                  <p>
                    事发位置：
                    <span> {{ item.reportAddress }} </span>
                  </p>
                </div>
                <div
                  v-show="
                    item.title !== '问题上报' && item.title !== '网格员核实'
                  "
                >
                  <p>
                    处置人：
                    <span> {{ item.handleUserName }} </span>
                  </p>
                  <p>
                    处置时间：
                    <span> {{ item.handleTime }} </span>
                  </p>
                </div>
                <div v-show="item.title == '网格员核实'">
                  <p>
                    核实人：
                    <span> {{ item.handleUserName }} </span>
                  </p>
                  <p>
                    核实时间：
                    <span> {{ item.finishTIme }} </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { taskDetail } from "@/api/systemManagement.js";
export default {
  meta: {
    title: "流转记录"
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {},
  data() {
    return {
      type: 0,
      list: []
    };
  },
  created() {},
  mounted() {
    this.getFlowRecord();
  },
  methods: {
    async getFlowRecord() {
      let res = await taskDetail({
        reportTaskId: this.id
      });
      console.log(res, "res");

      if (res.data.code == 200) {
        this.list = res.data.data.reverse();
        this.list.forEach(item => {
          if (item.json && typeof item.json === "string") {
            item.json = JSON.parse(item.json);
            item.json.forEach(items => {
              if (items.filePath) {
                items.url = process.env.VUE_APP_API_IMG_PATH + items.filePath;
              }
            });
          } else {
            item.json = [];
          }
        });
        console.log("222222", this.list);
      }
    }
  }
};
</script>

<style scoped lang="less">
.flowRecord {
  width: 50%;
}
.steps {
  height: calc(100vh - 60px);
  overflow: auto;
  padding: 16px;
  .content {
    // height: 100%;
    display: flex;
    // align-items: center;
    .content-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 4px;
      .round {
        width: 16px;
        height: 16px;
        border: 2px solid #0054feff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .solid {
        width: 0px;
        height: 100%;
        border-left: 1px solid #0054feff;
        margin: 6px 0px 2px 0px;
      }
      .dotted {
        width: 0px;
        height: 100%;
        border-left: 1px dashed #0054feff;
        margin: 6px 0px 2px 0px;
      }
    }

    .content-text {
      width: 100%;
      margin-left: 10px;
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 16px;
      color: #494c4f;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      .title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tag-box {
          // width: 56px;
          height: 22px;
          padding: 0px 14px;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          text-align: center;
          font-style: normal;
          margin-bottom: 8px;
        }
        .send-back {
          color: #eb3538;
          background-image: url("~@/assets/flowRecord/back1.png");
          background-size: 100% 100%;
        }
        .return {
          color: #00ac94ff;
          background-image: url("~@/assets/flowRecord/back2.png");
          background-size: 100% 100%;
        }
        .yes {
          color: #ff8b46;
          background-image: url("~@/assets/flowRecord/back3.png");
          background-size: 100% 100%;
        }
        .no {
          color: #0054feff;
          background-image: url("~@/assets/flowRecord/back4.png");
          background-size: 100% 100%;
        }
      }
      .title-text {
        margin-bottom: 8px;
      }

      .box {
        width: 100%;
        background: #f3f7f9;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 16px;
        .Ai {
          width: 100%;
          height: 60px;
          padding-bottom: 16px;
          background-image: url("~@/assets/flowRecord/back5.png");
          background-size: 90px 59px;
          background-position: right;
          background-repeat: no-repeat;
          display: flex;
          align-items: center;
          .title-ai {
            height: 20px;
            padding: 0px 8px;
            border-radius: 4px;
            border: 1px solid #0054fe;
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 14px;
            color: #0054fe;
            line-height: 19px;
            text-align: left;
            font-style: normal;
          }
        }

        .imgs {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          img {
            width: 88px;
            height: 88px;
            border-radius: 8px;
            margin-right: 16px;
          }
        }
        .dispose {
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 14px;
          color: #92979c;
          line-height: 22px;
          text-align: justify;
          font-style: normal;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reportproblemAnalysis/flowRecord.vue